<template>
  <div class="form-bg">
    <div class="form-bg-img">
      <div class="form-container">
        <h1 class="form-title">メール配信解除完了</h1>
        <p class="form-description">
          配信の解除を受け付けました。
          <br />
          配信停止のお手続き完了まで数日かかる場合がございます。予めご了承ください。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Success',
  data() {
    return {
      msg: 'Success!!',
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Success.vue